<template>
  <v-form v-if="!isUpdatingRouteGroup">
    <EditCheckpointLatLng
      @toggleEditCheckpointLatLng="editcheckpointlatlng = false; checkpointLatLngBeingEdited = undefined;"
      v-if="editcheckpointlatlng"
      :dialog="editcheckpointlatlng"
      :element="checkpointLatLngBeingEdited"
    ></EditCheckpointLatLng>
    <EditRouteGroup v-if="editRouteGroup"></EditRouteGroup>
    <EditRouteDescription v-if="editRouteDescription"></EditRouteDescription>

    <v-layout row wrap>
      <v-flex xs3>
        <v-btn
          :disabled="editMode"
          @click="editRouteView = 1"
          flat
          icon
          :color="editRouteView === 1?'primary':'default'"
        >
          <v-icon>call_split</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs3>
        <v-btn
          :disabled="editMode"
          @click="editRouteView = 2"
          flat
          icon
          :color="editRouteView === 2 ? 'primary':'default'"
        >
          <v-icon>place</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs3>
        <v-btn
          :disabled="editMode"
          @click="editRouteView = 3"
          flat
          icon
          :color="editRouteView === 3 ? 'primary':'default'"
        >
          <v-icon>settings</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-flex xs12 v-if="editRouteView === 1">
      <v-card>
        <span color="error" v-if="updateNameError">{{updateNameError}}</span>
        <v-text-field
          :placeholder="translater.__('Route')"
          :label="translater.__('Name')"
          v-model="routeName"
        ></v-text-field>

        <!--v-text-field
					:placeholder="translater.__('Lat')"
					:label="translater.__('Lat')"
					v-model="lat"
					@blur="updateLat"
        ></v-text-field-->

        <v-card-actions v-if="route.isDirty">
          <v-btn @click="updateRoute()" flat icon small color="success">
            <v-icon>check</v-icon>
          </v-btn>
          <v-btn @click="cancelUpdate()" flat icon small color="error">
            <v-icon>cancel</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="isLuonto">
        <v-card-actions>
          <v-btn color="primary" flat small @click="openEditRouteDescription()">
            <v-icon>edit</v-icon>
            {{translater.__('Description')}}
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="isLuonto">
        <v-card-title>
          <label>{{translater.__('Route Length ({0})', 'routes', 'km')}}</label>
        </v-card-title>
        <v-text-field :placeholder="translater.__('Route Length (km)')" v-model="routeLength"></v-text-field>
        <v-card-actions>
          <v-switch
            :label="translater.__('Calculate Length Automatically', 'routes')"
            v-model="calculateLengthAutomatically"
          ></v-switch>
          <v-btn v-if="!calculateLengthAutomatically" @click="updateRouteLength()" flat icon small>
            <v-icon>save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="control-buttons" v-if="!confirmRouteDelete">
        <v-card-actions>
          <!--v-btn color="success" small @click="updateRoute()">
						{{translater.__('Update')}}
						<v-icon>save</v-icon>
          </v-btn-->
          <v-btn v-if="!SOFT_DELETE" color="error" flat small @click="deleteRoute()">
            {{translater.__('Delete')}}
            <v-icon>delete</v-icon>
          </v-btn>
          <v-btn
            v-if="SOFT_DELETE === true && route.removed === false"
            color="error"
            flat
            small
            @click="destroyRoute()"
          >
            {{translater.__('Hide')}}
            <v-icon>visibility_off</v-icon>
          </v-btn>
        </v-card-actions>

        <v-card-actions v-if="route.removed === true && SOFT_DELETE">
          <v-btn color="error" flat small @click="destroyRoute(true)">
            {{translater.__('Delete')}}
            <v-icon>delete</v-icon>
          </v-btn>
          <v-btn color="primary" flat small @click="restoreRoute(route)">
            <v-icon>restore_from_trash</v-icon>
            {{translater.__('Restore')}}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="control-buttons" v-else>
        <v-card-title
          style="color:red;"
        >{{translater.__("Are you sure, you want to delete this route", 'routes')}}</v-card-title>
        <v-card-actions>
          <SuccessButton button-text="OK" :valid="true" :onClick="() => destroyRoute(true)"></SuccessButton>

          <ErrorButton :onClick="() => cancelRouteDelete()"></ErrorButton>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex v-else-if="editRouteView === 2">
      <v-card>
        <label>{{translater.__('Checkpoints', 'routes')}}</label>
      </v-card>
      <v-flex v-for="(element, i) in list" :key="i">
        <div v-if="!element.editable && !element.confirmDelete">
          <v-card>
            <v-card-title>
              <span
                :id="`routes${element._id}`"
                @dblclick="setFeatureEditable(element)"
                @click="openPopup(element)"
                :style="element.style"
              >{{element.properties.name}}</span>
              <span
                class="geofenceRadius"
                v-if="isLuonto"
                @dblclick="setGeofenceEditable(element)"
              >({{element.properties.geofence}}m)</span>
            </v-card-title>
            <v-card-actions>
              <div>
                <v-btn
                  v-if="!element.properties.removed"
                  :disabled="editMode"
                  @click="editCheckpoint(element)"
                  flat
                  small
                  icon
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn :disabled="editMode" @click="editCheckpointLatLng(element)" flat small icon>
                  <v-icon>place</v-icon>
                </v-btn>
                <v-btn
                  :disabled="editMode"
                  :color="getCheckpointDeleteColor(element)"
                  @click="() => {
																			if(SOFT_DELETE && !element.properties.removed){
																				deleteCheckpoint(element)
																				} else if(SOFT_DELETE && element.properties.removed){
																					destroyCheckpoint(element, true)
																					} else if(!SOFT_DELETE) {
																						deleteCheckpoint(element)
																		}}"
                  v-if="element.properties.isStart !== true
																		&& element.properties.isFinish !== true"
                  flat
                  small
                  icon
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <v-btn
                  @click="restoreCheckpoint(element)"
                  flat
                  small
                  color="primary"
                  icon
                  v-if="SOFT_DELETE && element.properties.removed && showRestoreCheckpoint"
                >
                  <v-icon>restore_from_trash</v-icon>
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </div>
        <v-card v-if="element.editable === true && !element.setConfirmDelete">
          <div v-if="geofenceEditable !== true">
            <v-card-title>{{translater.__('Checkpoint', 'features')}}</v-card-title>
            <v-card-text>
              <v-text-field :placeholder="translater.__('Checkpoint')" v-model="featureName"></v-text-field>
            </v-card-text>
          </div>
          <div v-else>
            <v-card-title>{{translater.__('Geofence radius', 'features')}}</v-card-title>
            <v-card-text>
              <v-text-field
                :placeholder="translater.__('Geofence radius')"
                :value="editableGeofence"
                @keyup.native="(e) => {setGeofenceRadius(e)}"
              ></v-text-field>
            </v-card-text>
          </div>
          <v-card-actions>
            <div>
              <v-btn color="success" @click="acceptFeatureEdit()" small icon flat>
                <v-icon>check</v-icon>
              </v-btn>
              <v-btn color="error" @click="cancelFeatureEdit()" small icon>
                <v-icon>cancel</v-icon>
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>

        <div v-if="element.confirmDelete === true && !element.editable">
          <v-card>
            <v-card-title>
              <span
                style="color: red"
              >{{translater.__('Are you sure, you want to delete this checkpoint', 'routes')}}</span>
            </v-card-title>
            <v-card-actions>
              <div>
                <v-btn color="success" @click="destroyCheckpoint(element, true)" flat small>
                  <v-icon>check_circle</v-icon>
                  {{translater.__('OK')}}
                </v-btn>
                <v-btn color="primary" @click="cancelDeleteCheckpoint()" flat small>
                  <v-icon>cancel</v-icon>
                  {{translater.__('Cancel')}}
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </div>
      </v-flex>
      <v-card>
        <v-card-actions>
          <v-btn :disabled="editMode" flat color="success" @click="addMarker();" small>
            {{translater.__('Add checkpoint', 'routes')}}
            <v-icon>add</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex v-else-if="editRouteView === 3">
      <v-card>
        <v-card-title>
          <v-card-actions>
            <v-switch :label="translater.__('Published', 'routes')" v-model="published"></v-switch>
          </v-card-actions>
        </v-card-title>
      </v-card>

      <v-card v-if="isLuonto">
        <v-card-title>
          <v-card-actions>
            <v-switch :label="translater.__('Accessible', 'routes')" v-model="accessible"></v-switch>
          </v-card-actions>
        </v-card-title>
      </v-card>
      <v-card>
        <v-card-title>{{translater.__('Keep marker attached to route node', 'routes')}}</v-card-title>
        <v-card-text>
          <v-switch v-model="attachMarkerToNode"></v-switch>
        </v-card-text>
      </v-card>
      <v-card v-if="isLuonto">
        <v-card-title>{{translater.__('Draw line automatically between two points', 'routes')}}</v-card-title>
        <v-card-text>
          <v-switch v-model="drawLineAutomatically"></v-switch>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-form>
</template>
<script>
import { SOFT_DELETE } from "../../../constants/";
import draggable from "vuedraggable";
import EditRouteGroup from "./EditRouteGroup";
import EditRouteDescription from "./EditRouteDescription";

import { setRoute } from "../../../tools/";
import SuccessButton from "../../../common/components/SuccessButton";
import ErrorButton from "../../../common/components/ErrorButton";
import EditCheckpointLatLng from "../../../routes/components/EditCheckpointLatLng";

export default {
  name: "EditRoute",
  components: {
    SuccessButton,
    ErrorButton,
    draggable,
    EditRouteGroup,
    EditRouteDescription,
    EditCheckpointLatLng
  },
  data() {
    return {
      valid: true,
      changeOrder: false,
      editableGeofence: null,
      updateNameError: null,
      SOFT_DELETE: SOFT_DELETE,
      showRestoreCheckpoint: false,
      editcheckpointlatlng: false,
      checkpointLatLngBeingEdited: undefined
    };
  },

  computed: {
    features() {
      return this.$store.getters["locations/features"];
    },

    editMode() {
      return this.$store.getters["routes/editMode"];
    },

    isLuonto: {
      get() {
        return this.$store.getters["settings/isLuonto"];
      }
    },

    geofenceEditable: {
      get() {
        return this.$store.getters["locations/geofenceEditable"];
      },

      set(value) {
        this.$store.dispatch("locations/setGeofenceEditable", value);
      }
    },

    calculateLengthAutomatically: {
      get() {
        return this.$store.getters["routes/calculateLengthAutomatically"];
      },

      set(value) {
        this.$store.dispatch("routes/setCalculateLengthAutomatically", value);
      }
    },

    editRouteView: {
      get() {
        return this.$store.getters["routes/editRouteView"];
      },

      set(value) {
        this.$store.commit("routes/setEditRouteView", value);
      }
    },

    isUpdatingRouteGroup: {
      get() {
        return this.$store.getters["routes/isUpdatingRouteGroup"];
      }
    },

    routeLength: {
      get() {
        return this.$store.getters["routes/routeLength"];
      },

      set(value) {
        this.$store.dispatch("routes/setRouteLength", value);
      }
    },

    drawLineAutomatically: {
      get() {
        return this.$store.getters["lines/drawLineAutomatically"];
      },

      set(value) {
        this.$store.commit("lines/setDrawLineAutomatically", value);
      }
    },

    attachMarkerToNode: {
      get() {
        return this.$store.getters["lines/attachMarkerToNode"];
      },

      set(value) {
        this.$store.commit("lines/setAttachMarkerToNode", value);
      }
    },

    /*canBeDetached: {
				get()
				{
					let cbd = this.$store.getters['routes/route'].canBeDetached;
					
					return cbd;
				}
			},*/

    editRouteDescription: {
      get() {
        return this.$store.getters["routes/editRouteDescription"];
      },

      set(value) {
        this.$store.commit("routes/setEditRouteDescription", value);
      }
    },

    editRouteGroup: {
      get() {
        return this.$store.getters["routes/editRouteGroup"];
      },

      set(value) {
        this.$store.commit("routes/setEditRouteGroup", value);
      }
    },

    selectedRouteGroup: {
      get() {
        return this.$store.getters["routes/route"].routegroup;
      },

      set(value) {
        this.$store.dispatch("routes/setSelectedRouteGroup", value);
      }
    },

    routeGroups: {
      get() {
        return this.$store.getters["routes/routeGroupsEdit"];
      }
    },

    route: {
      get() {
        let r = this.$store.getters["routes/route"];

        return r;
      }
    },

    updateLocation: {
      get() {
        return this.$store.getters["routes/updateLocation"];
      },

      set(value) {
        this.$store.dispatch("routes/setUpdateLocation", value);
      }
    },

    confirmRouteDelete: {
      get() {
        return this.$store.getters["routes/confirmRouteDelete"];
      },

      set(value) {
        this.$store.dispatch("routes/setConfirmRouteDelete", value);
      }
    },

    hightLighted: {
      get() {
        return this.$store.getters["locations/hightLighted"];
      }
    },

    isFetching: {
      get() {
        return this.$store.getters["locations/isFetching"];
      }
    },

    /*hasFinish: {
				get()
				{
					return this.$store.getters['routes/hasFinish'];
				}
			},*/

    featureName: {
      get() {
        return typeof this.$store.getters["routes/editableFeature"] ==
          "undefined"
          ? ""
          : this.$store.getters["routes/editableFeature"].properties.name;
      },

      set(value) {
        this.$store.dispatch("routes/setEditableFeatureName", value);
      }
    },

    published: {
      get() {
        return !this.$store.getters["routes/route"].disabled;
      },

      set(value) {
        value = !value;
        this.$store.dispatch("routes/setDisabled", value);
      }
    },

    accessible: {
      get() {
        return this.$store.getters["routes/route"].accessible;
      },

      set(value) {
        this.$store.dispatch("routes/setAccessible", value);
      }
    },

    routeName: {
      get() {
        return this.$store.getters["routes/route"].displayName;
      },

      set(value) {
        this.$store.dispatch("routes/setName", value);
      }
    },

    lat: {
      get() {
        return this.$store.getters["routes/route"].focusPoint.coordinates[1];
      },

      set(v) {
        this.$store.commit("routes/setLat", v);
      }
    },

    translater: {
      get() {
        return this.$store.getters["translate/translater"];
      }
    },

    list: {
      get() {
        let f = this.$store.getters["routes/route"].features;
        //
        return f;
      },

      set(value) {
        this.$store.dispatch("routes/sortFeatures", value);
      }
    }
  }
};
</script>

<style scoped>
label {
  margin-top: 1em;
  margin-bottom: 1em;
  font-weight: bold;
}

span.geofenceRadius {
  diplay: inline;
  margin-left: 1em;
}

.v-card__title {
  cursor: pointer;
}

.control-buttons {
  margin-top: 2em;
}
</style>
<template>
  <v-form v-if="!isUpdatingRouteGroup">
    <EditCheckpointLatLng
      @toggleEditCheckpointLatLng="editcheckpointlatlng = false; checkpointLatLngBeingEdited = undefined;"
      v-if="editcheckpointlatlng"
      :dialog="editcheckpointlatlng"
      :element="checkpointLatLngBeingEdited"
    ></EditCheckpointLatLng>
    <EditRouteGroup v-if="editRouteGroup"></EditRouteGroup>
    <EditRouteDescription v-if="editRouteDescription"></EditRouteDescription>

    <v-layout row wrap>
      <v-flex xs3>
        <v-btn
          :disabled="editMode"
          @click="editRouteView = 1"
          flat
          icon
          :color="editRouteView === 1?'primary':'default'"
        >
          <v-icon>call_split</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs3>
        <v-btn
          :disabled="editMode"
          @click="editRouteView = 2"
          flat
          icon
          :color="editRouteView === 2 ? 'primary':'default'"
        >
          <v-icon>place</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs3>
        <v-btn
          :disabled="editMode"
          @click="editRouteView = 3"
          flat
          icon
          :color="editRouteView === 3 ? 'primary':'default'"
        >
          <v-icon>settings</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-flex xs12 v-if="editRouteView === 1">
      <v-card>
        <span color="error" v-if="updateNameError">{{updateNameError}}</span>
        <v-text-field
          :placeholder="translater.__('Route')"
          :label="translater.__('Name')"
          v-model="routeName"
        ></v-text-field>

        <!--v-text-field
					:placeholder="translater.__('Lat')"
					:label="translater.__('Lat')"
					v-model="lat"
					@blur="updateLat"
        ></v-text-field-->

        <v-card-actions v-if="route.isDirty">
          <v-btn @click="updateRoute()" flat icon small color="success">
            <v-icon>check</v-icon>
          </v-btn>
          <v-btn @click="cancelUpdate()" flat icon small color="error">
            <v-icon>cancel</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="isLuonto">
        <v-card-actions>
          <v-btn color="primary" flat small @click="openEditRouteDescription()">
            <v-icon>edit</v-icon>
            {{translater.__('Description')}}
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="isLuonto">
        <v-card-title>
          <label>{{translater.__('Route Length ({0})', 'routes', 'km')}}</label>
        </v-card-title>
        <v-text-field :placeholder="translater.__('Route Length (km)')" v-model="routeLength"></v-text-field>
        <v-card-actions>
          <v-switch
            :label="translater.__('Calculate Length Automatically', 'routes')"
            v-model="calculateLengthAutomatically"
          ></v-switch>
          <v-btn v-if="!calculateLengthAutomatically" @click="updateRouteLength()" flat icon small>
            <v-icon>save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="control-buttons" v-if="!confirmRouteDelete">
        <v-btn
          v-if="!hasMatchingFocusPoint && !accessible"
          :disabled="accessible"
          color="primary"
          flat
          small
          @click="copyAccessible()"
        >
          {{translater.__('Copy Accessible', 'routes')}} &nbsp;
          <v-icon>backup</v-icon>
        </v-btn>
        <v-card-actions>
          <!--v-btn color="success" small @click="updateRoute()">
						{{translater.__('Update')}}
						<v-icon>save</v-icon>
          </v-btn-->
          <v-btn v-if="!SOFT_DELETE" color="error" flat small @click="deleteRoute()">
            {{translater.__('Delete')}}
            <v-icon>delete</v-icon>
          </v-btn>
          <v-btn
            v-if="SOFT_DELETE === true && route.removed === false"
            color="error"
            flat
            small
            @click="destroyRoute()"
          >
            {{translater.__('Hide')}}
            <v-icon>visibility_off</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-actions>
          <v-btn :to="{name: 'feedback', params: {id: route._id}}" color="primary" flat small>
            <v-icon>feedback</v-icon>
            {{translater.__('Feedback')}}
          </v-btn>
        </v-card-actions>
        <v-card-actions v-if="route.removed === true && SOFT_DELETE">
          <v-btn color="error" flat small @click="destroyRoute(true)">
            {{translater.__('Delete')}}
            <v-icon>delete</v-icon>
          </v-btn>
          <v-btn color="primary" flat small @click="restoreRoute(route)">
            <v-icon>restore_from_trash</v-icon>
            {{translater.__('Restore')}}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="control-buttons" v-else>
        <v-card-title
          style="color:red;"
        >{{translater.__("Are you sure, you want to delete this route", 'routes')}}</v-card-title>
        <v-card-actions>
          <SuccessButton button-text="OK" :valid="true" :onClick="() => destroyRoute(true)"></SuccessButton>

          <ErrorButton :onClick="() => cancelRouteDelete()"></ErrorButton>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex v-else-if="editRouteView === 2">
      <v-card>
        <label>{{translater.__('Checkpoints', 'routes')}}</label>
      </v-card>
      <v-flex v-for="(element, i) in list" :key="i">
        <div v-if="!element.editable && !element.confirmDelete">
          <v-card>
            <v-card-title>
              <span
                :id="`routes${element._id}`"
                @dblclick="setFeatureEditable(element)"
                @click="openPopup(element)"
                :style="element.style"
              >{{element.properties.name}}</span>
              <span
                class="geofenceRadius"
                v-if="isLuonto"
                @dblclick="setGeofenceEditable(element)"
              >({{element.properties.geofence}}m)</span>
            </v-card-title>
            <v-card-actions>
              <div>
                <v-btn
                  v-if="!element.properties.removed"
                  :disabled="editMode"
                  @click="editCheckpoint(element)"
                  flat
                  small
                  icon
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn :disabled="editMode" @click="editCheckpointLatLng(element)" flat small icon>
                  <v-icon>place</v-icon>
                </v-btn>
                <v-btn
                  :disabled="editMode"
                  :color="getCheckpointDeleteColor(element)"
                  @click="() => {
																			if(SOFT_DELETE && !element.properties.removed){
																				deleteCheckpoint(element)
																				} else if(SOFT_DELETE && element.properties.removed){
																					destroyCheckpoint(element, true)
																					} else if(!SOFT_DELETE) {
																						deleteCheckpoint(element)
																		}}"
                  v-if="element.properties.isStart !== true
																		&& element.properties.isFinish !== true"
                  flat
                  small
                  icon
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <v-btn
                  @click="restoreCheckpoint(element)"
                  flat
                  small
                  color="primary"
                  icon
                  v-if="SOFT_DELETE && element.properties.removed && showRestoreCheckpoint"
                >
                  <v-icon>restore_from_trash</v-icon>
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </div>
        <v-card v-if="element.editable === true && !element.setConfirmDelete">
          <div v-if="geofenceEditable !== true">
            <v-card-title>{{translater.__('Checkpoint', 'features')}}</v-card-title>
            <v-card-text>
              <v-text-field :placeholder="translater.__('Checkpoint')" v-model="featureName"></v-text-field>
            </v-card-text>
          </div>
          <div v-else>
            <v-card-title>{{translater.__('Geofence radius', 'features')}}</v-card-title>
            <v-card-text>
              <v-text-field
                :placeholder="translater.__('Geofence radius')"
                :value="editableGeofence"
                @keyup.native="(e) => {setGeofenceRadius(e)}"
              ></v-text-field>
            </v-card-text>
          </div>
          <v-card-actions>
            <div>
              <v-btn color="success" @click="acceptFeatureEdit()" small icon flat>
                <v-icon>check</v-icon>
              </v-btn>
              <v-btn color="error" @click="cancelFeatureEdit()" small icon>
                <v-icon>cancel</v-icon>
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>

        <div v-if="element.confirmDelete === true && !element.editable">
          <v-card>
            <v-card-title>
              <span
                style="color: red"
              >{{translater.__('Are you sure, you want to delete this checkpoint', 'routes')}}</span>
            </v-card-title>
            <v-card-actions>
              <div>
                <v-btn color="success" @click="destroyCheckpoint(element, true)" flat small>
                  <v-icon>check_circle</v-icon>
                  {{translater.__('OK')}}
                </v-btn>
                <v-btn color="primary" @click="cancelDeleteCheckpoint()" flat small>
                  <v-icon>cancel</v-icon>
                  {{translater.__('Cancel')}}
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </div>
      </v-flex>
      <v-card>
        <v-card-actions>
          <v-btn :disabled="editMode" flat color="success" @click="addMarker();" small>
            {{translater.__('Add checkpoint', 'routes')}}
            <v-icon>add</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex v-else-if="editRouteView === 3">
      <v-card>
        <v-card-title>
          <v-card-actions>
            <v-switch :label="translater.__('Published', 'routes')" v-model="published"></v-switch>
          </v-card-actions>
        </v-card-title>
      </v-card>

      <v-card v-if="isLuonto">
        <v-card-title>
          <v-card-actions>
            <v-switch :label="translater.__('Accessible', 'routes')" v-model="accessible"></v-switch>
          </v-card-actions>
        </v-card-title>
      </v-card>
      <v-card>
        <v-card-title>{{translater.__('Keep marker attached to route node', 'routes')}}</v-card-title>
        <v-card-text>
          <v-switch v-model="attachMarkerToNode"></v-switch>
        </v-card-text>
      </v-card>
      <v-card v-if="isLuonto">
        <v-card-title>{{translater.__('Draw line automatically between two points', 'routes')}}</v-card-title>
        <v-card-text>
          <v-switch v-model="drawLineAutomatically"></v-switch>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-form>
</template>
<script>
import { SOFT_DELETE } from "../../../constants/";
import draggable from "vuedraggable";
import EditRouteGroup from "./EditRouteGroup";
import EditRouteDescription from "./EditRouteDescription";

import { setRoute } from "../../../tools/";
import SuccessButton from "../../../common/components/SuccessButton";
import ErrorButton from "../../../common/components/ErrorButton";
import EditCheckpointLatLng from "../../../routes/components/EditCheckpointLatLng";

export default {
  name: "EditRoute",
  components: {
    SuccessButton,
    ErrorButton,
    draggable,
    EditRouteGroup,
    EditRouteDescription,
    EditCheckpointLatLng
  },
  data() {
    return {
      valid: true,
      changeOrder: false,
      editableGeofence: null,
      updateNameError: null,
      SOFT_DELETE: SOFT_DELETE,
      showRestoreCheckpoint: false,
      editcheckpointlatlng: false,
      checkpointLatLngBeingEdited: undefined
    };
  },

  methods: {
    copyAccessible() {
      this.$store
        .dispatch("routes/copyAccessible")
        .then(res => {
          if (res.status === 200) {
            window.vm.$emit("routeAdded");
            window.vm.$emit("hideLocations");
            this.$store.dispatch(
              "locations/setShowSelectedLocationDialog",
              false
            );
          }
        })
        .catch(err => {
          console.log(err.response.data.message);
          this.copyAccessibleError = err.response.data.message;
          window.setTimeout(() => {
            this.copyAccessibleError = null;
          }, 5000);
        });
    },

    getElementLeafletId(element) {
      let features = Object.keys(this.features).map(f => {
        return this.features[f];
      });

      features = features.flat();

      let feature = features.find(f => {
        return f.location._id == element._id;
      });

      return feature.leafletid;
    },

    editCheckpointLatLng(element) {
      let leafletid = this.getElementLeafletId(element);
      this.checkpointLatLngBeingEdited = { ...element, leafletid };
      this.editcheckpointlatlng = true;
    },

    updateLat() {},

    restoreRoute(r) {
      //this.$store.dispatch('routes/restore', r)
      window.vm.$emit("restoreRoute", r);
    },

    restoreCheckpoint(element) {
      this.$store.dispatch("locations/restore", element);
    },

    getCheckpointDeleteColor(element) {
      let c = "default";
      if (SOFT_DELETE && element.properties.removed) {
        c = "error";
      } else if (!SOFT_DELETE) {
        c = "error;";
      }

      return c;
    },

    setGeofenceEditable(element) {
      this.geofenceEditable = true;
      this.setFeatureEditable(element);
      this.editableGeofence = element.properties.geofence;
    },

    updateRouteLength() {
      this.$store.dispatch("routes/updateRouteLength");
    },

    setGeofenceRadius(e) {
      if (!isNaN(parseFloat(e.target.value))) {
        this.editableGeofence = e.target.value;
      }
    },

    updateGeofenceRadius() {
      //location.properties.geofence = this.editableGeofence;
      this.$store.dispatch(
        "locations/updateGeofenceRadius",
        this.editableGeofence
      );
    },

    cancelUpdate() {
      this.$store.dispatch("routes/cancelUpdate");
    },

    openEditRouteGroup() {
      this.editRouteGroup = true;
    },

    openEditRouteDescription() {
      this.editRouteDescription = true;
    },

    /*detach()
			{
				this.$store.dispatch('routes/detachFromRouteGroup')
				.then((res) => {
					if(res.status == 200)
					{
						/*setRoute(
							this.$store.getters['routes/route'],
							this.$store
						);*/

    /*window.vm.$emit('routeUpdated');
					}
				})
			},*/

    destroyRoute(hardDelete = false) {
      this.confirmRouteDelete = false;
      window.vm.$emit("destroyRoute", hardDelete);
    },

    cancelRouteDelete() {
      this.confirmRouteDelete = false;
    },

    deleteRoute() {
      this.confirmRouteDelete = true;
    },

    editCheckpoint(element) {
      this.$store.dispatch("routes/setFeatureEditable", element._id);

      this.$store.commit("checkpoints/flushIsBeingReplaced");

      this.$store.dispatch("checkpoints/checkPoint", element);
    },

    destroyCheckpoint(element, hardDelete = false) {
      this.$store
        .dispatch("locations/destroy", { element, hardDelete })
        .then(() => {
          setRoute(this.$store.getters["routes/route"], this.$store);
        });
    },

    cancelDeleteCheckpoint() {
      this.$store.dispatch("routes/cancelDeleteCheckpoint");
    },

    deleteCheckpoint(element) {
      this.$store.dispatch("routes/setConfirmDelete", element);
    },

    updateRoute() {
      this.confirmRouteDelete = false;
      this.$store
        .dispatch("routes/update")
        .then(route => {
          console.log("editroute");
          this.$emit("onRouteUpdate", route);
          //console.log("sdflkjsfdlksdfdfsl");
          setRoute(this.$store.getters["routes/route"], this.$store);
        })
        .catch(err => {
          this.updateNameError = err.response.data.message;
          window.setTimeout(() => {
            this.updateNameError = null;
          }, 3000);
        });
    },

    cancelFeatureEdit() {
      this.geofenceEditable = false;
      this.$store.dispatch("routes/cancelFeatureEdit");
    },

    acceptFeatureEdit() {
      if (this.geofenceEditable === false) {
        this.$store.dispatch("routes/acceptFeatureEdit");
      } else {
        this.updateGeofenceRadius();
      }
    },

    setFeatureEditable(element) {
      this.$store.dispatch("routes/setFeatureEditable", element._id);
    },

    addMarker() {
      window.vm.$emit("addMarker");
    },

    openPopup(element) {
      this.$store.dispatch("routes/setHighLighted", element._id);
      let popupIdPromise = this.$store.dispatch(
        "locations/setActivePopup",
        element._id
      );
      //
      if (typeof popupIdPromise !== "undefined") {
        popupIdPromise
          .then(id => {
            this.$store.commit("locations/setActivePopup", id);
            window.vm.$emit("openPopup", id);
          })
          .catch(() => {});
      }
    }
  },

  computed: {
    hasMatchingFocusPoint: {
      get() {
        let has = false;
        /* if (this.$store.getters['routes/matchingFocusPoints'][this.route._id].length > 1) {
					 	has = true;
					 }*/

        let routeId = this.route._id;
        let matching = this.$store.getters["routes/matchingFocusPoints"][
          routeId
        ];

        if (
          (typeof matching !== "undefined" && matching.length > 1) ||
          typeof matching === "undefined"
        ) {
          has = true;
        }

        return has;
      }
    },

    features() {
      return this.$store.getters["locations/features"];
    },

    editMode() {
      return this.$store.getters["routes/editMode"];
    },

    isLuonto: {
      get() {
        return this.$store.getters["settings/isLuonto"];
      }
    },

    geofenceEditable: {
      get() {
        return this.$store.getters["locations/geofenceEditable"];
      },

      set(value) {
        this.$store.dispatch("locations/setGeofenceEditable", value);
      }
    },

    calculateLengthAutomatically: {
      get() {
        return this.$store.getters["routes/calculateLengthAutomatically"];
      },

      set(value) {
        this.$store.dispatch("routes/setCalculateLengthAutomatically", value);
      }
    },

    editRouteView: {
      get() {
        return this.$store.getters["routes/editRouteView"];
      },

      set(value) {
        this.$store.commit("routes/setEditRouteView", value);
      }
    },

    isUpdatingRouteGroup: {
      get() {
        return this.$store.getters["routes/isUpdatingRouteGroup"];
      }
    },

    routeLength: {
      get() {
        return this.$store.getters["routes/routeLength"];
      },

      set(value) {
        this.$store.dispatch("routes/setRouteLength", value);
      }
    },

    drawLineAutomatically: {
      get() {
        return this.$store.getters["lines/drawLineAutomatically"];
      },

      set(value) {
        this.$store.commit("lines/setDrawLineAutomatically", value);
      }
    },

    attachMarkerToNode: {
      get() {
        return this.$store.getters["lines/attachMarkerToNode"];
      },

      set(value) {
        this.$store.commit("lines/setAttachMarkerToNode", value);
      }
    },

    /*canBeDetached: {
				get()
				{
					let cbd = this.$store.getters['routes/route'].canBeDetached;
					
					return cbd;
				}
			},*/

    editRouteDescription: {
      get() {
        return this.$store.getters["routes/editRouteDescription"];
      },

      set(value) {
        this.$store.commit("routes/setEditRouteDescription", value);
      }
    },

    editRouteGroup: {
      get() {
        return this.$store.getters["routes/editRouteGroup"];
      },

      set(value) {
        this.$store.commit("routes/setEditRouteGroup", value);
      }
    },

    selectedRouteGroup: {
      get() {
        return this.$store.getters["routes/route"].routegroup;
      },

      set(value) {
        this.$store.dispatch("routes/setSelectedRouteGroup", value);
      }
    },

    routeGroups: {
      get() {
        return this.$store.getters["routes/routeGroupsEdit"];
      }
    },

    route: {
      get() {
        let r = this.$store.getters["routes/route"];

        return r;
      }
    },

    updateLocation: {
      get() {
        return this.$store.getters["routes/updateLocation"];
      },

      set(value) {
        this.$store.dispatch("routes/setUpdateLocation", value);
      }
    },

    confirmRouteDelete: {
      get() {
        return this.$store.getters["routes/confirmRouteDelete"];
      },

      set(value) {
        this.$store.dispatch("routes/setConfirmRouteDelete", value);
      }
    },

    hightLighted: {
      get() {
        return this.$store.getters["locations/hightLighted"];
      }
    },

    isFetching: {
      get() {
        return this.$store.getters["locations/isFetching"];
      }
    },

    /*hasFinish: {
				get()
				{
					return this.$store.getters['routes/hasFinish'];
				}
			},*/

    featureName: {
      get() {
        return typeof this.$store.getters["routes/editableFeature"] ==
          "undefined"
          ? ""
          : this.$store.getters["routes/editableFeature"].properties.name;
      },

      set(value) {
        this.$store.dispatch("routes/setEditableFeatureName", value);
      }
    },

    published: {
      get() {
        return !this.$store.getters["routes/route"].disabled;
      },

      set(value) {
        value = !value;
        this.$store.dispatch("routes/setDisabled", value);
      }
    },

    accessible: {
      get() {
        return this.$store.getters["routes/route"].accessible;
      },

      set(value) {
        this.$store.dispatch("routes/setAccessible", value);
      }
    },

    routeName: {
      get() {
        return this.$store.getters["routes/route"].displayName;
      },

      set(value) {
        this.$store.dispatch("routes/setName", value);
      }
    },

    lat: {
      get() {
        return this.$store.getters["routes/route"].focusPoint.coordinates[1];
      },

      set(v) {
        this.$store.commit("routes/setLat", v);
      }
    },

    translater: {
      get() {
        return this.$store.getters["translate/translater"];
      }
    },

    list: {
      get() {
        let f = this.$store.getters["routes/route"].features;
        //
        return f;
      },

      set(value) {
        this.$store.dispatch("routes/sortFeatures", value);
      }
    }
  }
};
</script>

<style scoped>
label {
  margin-top: 1em;
  margin-bottom: 1em;
  font-weight: bold;
}

span.geofenceRadius {
  diplay: inline;
  margin-left: 1em;
}

.v-card__title {
  cursor: pointer;
}

.control-buttons {
  margin-top: 2em;
}
</style>
